import { callApi } from "./api";
import * as transforms from "./transforms";
export const TEXT_EFFECTS_ROOT = process.env.REACT_APP_TEXT_EFFECTS_URL;

export function transformDesignPostRequest(request) {
  return {
    name: request.name,
    original_design_id: request.original_design_id,
    product_type_id: request.product_type_id,
    product_option_id: request.product_option_id,
    product_variant_id: request.product_variant_id,
    selected_print_option: request.selected_print_option,
    layer_set: request.layer_set.map((layer) => {
      const newLayer = {
        ...layer
      };
      newLayer.colors = undefined;
      newLayer.print_colors = undefined;
      return newLayer;
    })
  };
}

// api services
export const saveDesign = (
  design,
  overwrite,
  orderItemId,
  orderNumber,
  purchasedItemID,
  savedByCustomer
) => {
  const params = {
    headers: {
      "Content-Type": "application/json"
    },
    method: "POST",
    need_csrf: true,
    body: JSON.stringify(transformDesignPostRequest(design))
  };

  let url = "design";
  if (design.id && overwrite === true) {
    url = url + "/entity/" + design.id;
    params.method = "PATCH";
  }
  url = url + "?_format=json";
  if (design.id && orderItemId) {
    url = url + "&orderItemId=" + orderItemId;
  }

  if (design.id && orderNumber && purchasedItemID) {
    url =
      url +
      "&orderNumber=" +
      orderNumber +
      "&purchasedItemID=" +
      purchasedItemID;
  }

  if (savedByCustomer) {
    url = url + "&savedByCustomer=1";
  }

  return callApi(url, params).then((response) => {
    if (response.response && response.response) {
      let result = { response: response.response };
      result.response.savedVersion = design.version;
      return result;
    } else {
      return { error: response.error };
    }
  });
};

// api services
export const fetchDesign = (id) => {
  return callApi("design/entity/" + id + "?_format=json").then((response) => {
    if (response.response) {
      const product_option = response.response.field_product_option;
      const product_variant = response.response.field_product_variant;

      const output = {
        design: transforms.transformDesign(response.response),
        product_option: transforms.transformProductOption(product_option),
        product_variant: transforms.transformProductVariant(product_variant)
      };

      return { response: output };
    } else {
      return { response: {} };
    }
  });
};

// Copy design api service
export const fetchCopiedDesign = (designId, copyId, nocontent) => {
  const queryString = nocontent ? "?nocontent=1" : "";
  const url = `design/${designId}/copy/${copyId}.json${queryString}`;
  return callApi(url, {}, "json", TEXT_EFFECTS_ROOT).then((response) => {
    if (response.response) {
      const product_option = response.response.field_product_option;
      const product_variant = response.response.field_product_variant;

      const output = {
        design: transforms.transformDesign(response.response),
        product_option: transforms.transformProductOption(product_option),
        product_variant: transforms.transformProductVariant(product_variant)
      };

      return { response: output };
    } else {
      return { response: {} };
    }
  });
};
